var render = function render(){var _vm=this,_c=_vm._self._c;return _c('markdown-renderer',{attrs:{"source":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }